import { DocumentUpload, WeightMeter, Ruler, TickSquare } from "iconsax-react";
import { FreeTrialServiceStepProps } from "../../types/free-trial/steps/type";

export const BODY_MEASUREMENT_SERVICE_STEPS: FreeTrialServiceStepProps[] = [
  { id: "upload-pic", label: "Upload Image", svg: <DocumentUpload variant="Broken" /> },
  { id: "height", label: "Height", svg: <WeightMeter variant="Broken" /> },
  { id: "measurement", label: "Processing", svg: <Ruler variant="Broken" /> },
  { id: "result", label: "Result", svg: <TickSquare variant="Broken" /> },
];
